import { useMemo } from 'react';

import { getTransportUnitPositions } from '../helpers/transportUnitPositions';
import { getPlacedQuantityByLineItem, getUnitTotals } from '../state/packingListReducer';
import { getPlacedContentByKey, getProducts, getRemainingByLineItem } from '../state/selectors';
import { PackingListTree } from '../types';

export const useDerivedPackingList = (packingList: PackingListTree, quantityFieldPath: string) => {
  const placedByLineItem = useMemo(
    () => getPlacedQuantityByLineItem(packingList.transportUnits),
    [packingList.transportUnits],
  );
  const { placed, total } = useMemo(
    () => getUnitTotals(packingList, placedByLineItem, quantityFieldPath),
    [packingList, placedByLineItem, quantityFieldPath],
  );
  const products = useMemo(
    () => getProducts(packingList.lineItems, quantityFieldPath),
    [packingList.lineItems, quantityFieldPath],
  );
  const remainingByLineItem = useMemo(
    () => getRemainingByLineItem(products, placedByLineItem, quantityFieldPath),
    [products, placedByLineItem, quantityFieldPath],
  );
  const placedContentByKey = useMemo(
    () => getPlacedContentByKey(packingList.transportUnits),
    [packingList.transportUnits],
  );
  const tuPositionById = useMemo(
    () => getTransportUnitPositions(packingList.transportUnits),
    [packingList.transportUnits],
  );

  const unplacedCount = total - placed;

  return {
    products,
    remainingByLineItem,
    placedContentByKey,
    tuPositionById,
    placed,
    total,
    unplacedCount,
  };
};
